<div class="panel-body ">
  <ng-container *ngFor="let party of civilCase.getPartyList(); let pt = index">
     <div class="col-md-12 panel panel-default panel-margin-bottom panel-margin-top">
       <div class="panel-title" id="{{'civil-caseDetails-parties-' + pt + '-partyNumber'}}">
          <span [id]="'P-' + party.getPartyKey()">
            <span class="field-code">V068a json='caseParties.name'</span> {{party.getName()}} <span class="field-code">V052a V053a json='partyRole.description','caseParties.partyNumber'</span>({{party.getPartyRole()}}
          {{party.getPartyNumber()}})
          </span>
       </div>
       <div class="panel-body">
          <div class="row" *ngIf="party.getAliasList().length !== 0">
            <div class="col-md-12 panel panel-default">
              <div class="panel-title" id="{{'V096a-'+pt}}"><span class="field-code">V096a json='aliasList.name'</span>Alias Names</div>
              <div class="panel-body" *ngIf="party.getAliasList().length > 0">
                <ol class="four-column">
                   <li *ngFor="let alias of party.getAliasList(); let al = index" id="{{'civil-caseDetails-parties-' + pt + '-alias-' + al + '-name'}}">
                      {{party.getAliasName(alias)}}
                   </li>
                </ol>
              </div>
            </div>
          </div>

          <div class="row" *ngIf="party.getUpdatedNamesList().length !== 0">
            <div class="col-md-12 panel panel-default">
              <div class="panel-title" id="{{'V518-'+pt}}"><span class="field-code">V518 json='updatedNamesList.name'</span>Updated Names</div>
              <div class="panel-body" *ngIf="party.getUpdatedNamesList().length > 0">
                <ol class="four-column">
                  <li *ngFor="let updatedName of party.getUpdatedNamesList(); let al = index" id="{{'civil-caseDetails-parties-' + pt + '-updatedName-' + al + '-name'}}">
                      {{party.getUpdatedName(updatedName)}}
                  </li>
                </ol>
              </div>
            </div>
          </div>

          <div class="row row-eq-height">
            <div *ngIf="party.getTitle() !== '-'" class="col-md-3 panel panel-default">
              <div id="{{'V107-'+pt}}" class="panel-title">
                <span class="field-code">V107 json='partyTitle.partyTitle.description'</span>Title
              </div>
              <div class="panel-body" id="{{'civil-caseDetails-parties-' + pt + '-title'}}">
                {{party.getTitle()}}
              </div>
            </div>
            <div *ngIf="party.getHasJudgements() !== ''" class="col-md-3 panel panel-default">
              <div id="{{'V099-'+pt}}" class="panel-title">
                <span class="field-code ">V099 json='caseParties.judgmentIndexed'</span>Has Indexed Judgment(s)
              </div>
              <div class="panel-body " id="{{'civil-caseDetails-parties-' + pt + '-hasJudgements'}}">
                {{party.getHasJudgements()}}
              </div>
            </div>
          </div>

          <div class="row row-eq-height">
            <div *ngIf="party.getReasonFilingFeeDeferred() !== '-'" class="col-md-3 panel panel-default">
              <div id="{{'V110-'+pt}}" class="panel-title ">
                <span class="field-code ">V110 json='caseParties.indigencyIndicator'</span>Reason Costs Were Deferred
              </div>
              <div class="panel-body " id="{{'civil-caseDetails-parties-' + pt + '-reasonFilingFeeDeferred'}}">
                {{party.getReasonFilingFeeDeferred()}}
              </div>

            </div>
            <div *ngIf="party.getPartyDate() !== ''" class="col-md-3 panel panel-default">
              <div id="{{'V105-'+pt}}" class="panel-title ">
                <span class="field-code ">V105 json=partyTitle.partyTitle.code#, civilCase.caseNumber.fileNumber#, caseParties.date</span> 
                 {{party.getPartyDateLabel(civilCase)}}
              </div>
              <div *ngIf="party.getTitleCode() !== 'E'" class="panel-body " id="{{'civil-caseDetails-parties-' + pt + '-partyDate'}}">
                {{party.getPartyDate() | date:'MM/dd/yyyy'}}
              </div>
              <div *ngIf="party.getTitleCode() === 'E'" class="panel-body " id="{{'civil-caseDetails-parties-' + pt + '-partyDate'}}">
                  {{party.getPartyDate() | date:'yyyy'}}
                </div>              
            </div>
            <div *ngIf="party.getDepartmentOfInsuranceLicenseNumber(civilCase) !== '-'" class="col-md-6 panel panel-default ">
              <div id="{{'V108-'+pt}}" class="panel-title ">
                <span class="field-code ">V108 json='partyTitle.partyTitle.code#, civilCase.caseNumber.fileNumber#, suretySequenceNumber'</span>Department of Insurance License Number
              </div>
              <div class="panel-body " id="{{'civil-caseDetails-parties-' + pt + '-departmentOfInsuranceLicenseNumber'}}">
                {{party.getDepartmentOfInsuranceLicenseNumber(civilCase)}}
              </div>
            </div>
            <div class="col-md-3 panel panel-default" *ngIf="party?.getBankruptcyStatus() ">
              <div id="{{'V100a-'+pt}}" class="panel-title">
                <span class="field-code ">V100a json='caseParties.status'</span>Notice of Bankruptcy Filed
              </div>
              <div class="panel-body " id="{{'civil-caseDetails-parties-' + pt + '-status'}}">
                <div > {{party.getBankruptcyStatus()}}</div>
              </div>
            </div>
          </div>

          <div class="row row-eq-height" *ngFor="let address of party.getPartyAddressList(); let ad = index">
            <div *ngIf="party.getPartyAddressIsBlank(address) === false" class="col-md-6 panel panel-default">
              <div id="{{'X112-'+pt}}" class="panel-title">
                Address
              </div>
              <div *ngIf="party.getPartyAddressIsBlank(address) === false" class="panel-body">
                <div *ngIf="! party.getShowPrivacyMessage(address, true)">                
                  <span class="field-code">V111 Show table or not. json='privacyIndicatorCode.code#'</span>
                  <div class="table-responsive">
                    <table id="partyAddress-table">
                      <tbody>                      
                        <tr>
                          <td>
                            <span class="field-code">V112a json='address.line1' </span>
                            <span id="{{'civil-caseDetails-parties-' + pt + '-address-' + ad + '-partyAddressesLine1'}}">   
                              {{party.getPartyAddressesLine1(address)}}
                            </span>
                          </td>
                        </tr>

                        <tr>
                          <td>
                            <span id="V113a" class="field-code">V113a json='address.line2'</span>
                            <span id="{{'civil-caseDetails-parties-' + pt + '-address-' + ad + '-partyAddressesLine2'}}"> 
                              {{party.getPartyAddressesLine2(address)}}
                            </span>
                          </td>
                        </tr> 

                        <tr>
                          <td>
                            <span id="V115a" class="field-code">V115a, V116a, V117a json='address.cityName'</span>
                            <span id="{{'civil-caseDetails-parties-' + pt + '-address-' + ad + '-partyAddressesCityStateZipCodeName'}}">
                              {{party.partyAddressesCityStateZipCodeName(address)}}
                            </span>
                          </td>
                        </tr>
                        
                        <tr>
                          <td>
                            <span id="V114a" class="field-code">V114a, V118a json='address.stateAbbreviation.code,address.countryAbbreviation'</span>
                            <span id="{{'civil-caseDetails-parties-' + pt + '-address-' + ad + '-address.countyResidence'}}">
                              {{party.getPartyCounty(address)}}</span><span id="{{'civil-caseDetails-parties-' + pt + '-address-' + ad + '-address.countryAbbreviation'}}">{{party.getPartyCountry(address)}}</span>
                          </td>
                        </tr>                       
                      </tbody>
                    </table>
                  </div>                 
                </div>
                <div *ngIf="party.getShowPrivacyMessage(address, true)">
                    <div id="{{'civil-caseDetails-parties-' + pt + '-address-partyAddressesPrivate'}}">
                      <span id="V112" class="field-code">V112 </span> Address is confidential
                    </div>
                </div>
              </div>              
            </div>
            <div *ngIf="party.getPartyPhoneNumber(address) !== '-' || party.getPartyFaxNumber(address) !== '-'" class="col-md-6 panel panel-default">
              <div id="{{'X119-'+pt}}" class="panel-title">
                Phone Numbers
              </div>
              <div class="panel-body">
                <span class="field-code">json='privacyIndicatorCode.code#'</span>
                <dl class="dl-vertical">
                   <div *ngIf="party.getPartyPhoneNumber(address) !== '-'">
                      <dt id="{{'V119-'+pt}}" class="summary-label">
                        <span class="field-code">V119 json='address.phoneNumberExtension','address.phoneNumber'</span>Phone
                      </dt>
                      <dd id="{{'civil-caseDetails-parties-' + pt + '-partyPhoneNumber'}}">
                        {{party.getPartyPhoneNumber(address)}}
                      </dd>
                   </div>
                  <div *ngIf="party.getPartyFaxNumber(address) !== '-'">
                  <dt  id="{{'V120-'+pt}}" class="summary-label">
                    <span class="field-code">V120 json='address.faxNumber'</span>Fax
                  </dt>
                  <dd id="{{'civil-caseDetails-parties-' + pt + '-partyFaxNumber'}}">
                    {{party.getPartyFaxNumber(address)}}
                  </dd>
                  </div>
                </dl>
              </div>
            </div>
          </div>

          <div class="row " *ngIf="party.getPartyAttorneyList().length !== 0">
            <div class="col-md-12 panel panel-default ">
              <div id="{{'X122a-'+pt}}" class="panel-title ">
                Attorneys
              </div>
              <div class="panel-body ">
                <table id="{{'partyAttorney-table-' + pt}}" class="table table-condensed table-striped ">
                  <thead>
                    <tr>
                      <th id="{{'V122a-'+pt}}"><span class="field-code ">V122a json='attorney.name','primaryIndicator#'</span>Name</th>
                      <th id="{{'V121a-'+pt}}"><span class="field-code ">V121a json='primaryIndicator#','attorney.barNumber#</span> North Carolina State Bar Number</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let attorney of party.getPartyAttorneyList(); let at = index">
                      <td id="{{'civil-caseDetails-parties-' + pt + '-attorney-' + at + '-attorneyName'}}">
                        {{party.getAttorneyName(attorney)}} {{party.getAttorneyPrimaryIndicator(attorney, party.getPartyAttorneyList().length)}}
                      </td>
                      <td id="{{'civil-caseDetails-parties-' + pt + '-attorney-' + at + '-attorneyBarNumber'}}">
                        {{party.getAttorneyBarNumber(attorney)}}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
     </div>
  </ng-container>
</div>


// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/case-view/civil/parties/parties.component.html